import React, { useRef } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import styled from 'styled-components';
import Carousel from "react-multi-carousel";
import { useExternalMedia } from '../../../../hooks/useExternalMedia';







export default function HeroSliders() {



  const carouselRef = useRef<any>(null);


  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


  const {
    heroSlider1,
    heroSlider2,
    heroSlider3,
  } = useExternalMedia();

  const sliderImages: string[] = [
    heroSlider1,
    heroSlider2,
    heroSlider3,
  ];


  return (
    <Wrapper>
      <Container>
        <Row
          className="hero-slider-carousel-wrapper"
        >
          <Col
            sm={{ span: 12, order: 1 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 12, order: 1 }}
          >
            <Carousel
              responsive={responsive}
              ref={carouselRef}
              infinite={true}
              autoPlay={true}
              arrows={false}
              renderButtonGroupOutside={false}
              ssr={true}
              swipeable={true}
              keyBoardControl={true}
              showDots={false}
              containerClass="carousel-container"
              itemClass="carousel-item-padding-40-px"
            >

              {
                sliderImages.map((item) => {
                  return (
                    <HeroSliderCarouselWrapper
                      key={item}
                    >
                      <CarouselItem
                        style={{
                          backgroundImage: `url(${item})`
                        }}
                      ></CarouselItem>
                    </HeroSliderCarouselWrapper>
                  )
                })
              }
            </Carousel>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
};




const Wrapper = styled.div`
  min-width: 100% !important;
  margin-top: -10rem;

  @media (min-width: 768px) {
    margin-top: -20rem;
  }
`;


const HeroSliderCarouselWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem !important;
`;

const CarouselItem = styled.div`
  background-size: contain;
  background-position: top;
  background-repeat: no-repeat;
  width: 307px;
  height: 592px;
  cursor: grab;

    &:active,
    &:focus
    {
      cursor: grabbing;
    }

    @media (min-width: 768px) {
      width: 857px;
    }
`;
